// extracted by mini-css-extract-plugin
module.exports = {"dropdown-pre-icon":"HeaderDropdown_dropdown-pre-icon__1t7ry"};